import React, { useMemo } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";
import { PlusIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import CustomDataGridClient from "../../../components/elements/CustomDataGridClient";
import ControlledReactSelect from "../../../components/elements/ControlledReactSelect";
import ControlledInput from "../../../components/elements/ControlledInput";
import { getFetcher, postFetcher, patchFetcher } from "../../../services/api";
import RootAdmin from "../../../components/layouts/RootAdmin";
import useFormatNomorSurat from "../../../hooks/useFormatNomorSurat";

export default function FormatNomorSuratPage() {
  
  // Fetch data format nomor surat
  const { data, isLoading, mutate} = useSWR(`/api/nomor-surat/all`, getFetcher);
  
  const { 
    isEdit,
    onClickEdit,
    onCloseForm,
    onSubmitForm,
    modalForm: { onOpenModalForm, isOpenModalForm, onOpenChangeModalForm },
    hookForm: { control, handleSubmit, formState: { isSubmitting } },
  } = useFormatNomorSurat(mutate);


  const columns = useMemo(() => [
    { field: "documentType", headerName: "Tipe Dokumen" },
    { field: "formatNomorSurat", headerName: "Format Nomor Surat" },
    {
      field: "actions",
      headerName: "Aksi",
      renderCell: (params) => (
        <div className="flex gap-2">
          <Button color="primary" isIconOnly size="sm" onPress={() => onClickEdit(params?.row)}>
            <PencilSquareIcon className="size-4" />
          </Button>
        </div>
      ),
    },
  ], [onClickEdit]);

  return (
    <RootAdmin>
      <Card radius="sm">
        <CardHeader>
          Kelola Format Nomor Surat
        </CardHeader>
        <Divider />
        <CardBody>
          <div className="mb-5">
            <Button onPress={onOpenModalForm} size="sm" color="primary" startContent={<PlusIcon className="size-4 stroke-2"/>}>
              Tambah Format
            </Button>
          </div>
          <div className="h-[500px]">
            {/*
              Endpoint /api/nomor-surat/all memulangkan SELURUH baris sekaligus.
              Pembungkus bermode server tidak memotongnya, jadi semua baris
              dijejalkan ke satu halaman, dan tombol halaman berikutnya memanggil
              setPage yang memang tidak pernah dikirim. Paginasi sisi klien
              memotong dan menghitung sendiri.
            */}
            <CustomDataGridClient
              data={data?.data || []}
              isLoading={isLoading}
              columns={columns}
            />
          </div>
        </CardBody>
      </Card>

      <Modal size="2xl" isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseForm} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>{isEdit ? "Edit Format Nomor Surat" : "Tambah Format Nomor Surat"}</ModalHeader>
              <ModalBody>
                <form onSubmit={handleSubmit(onSubmitForm)}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5">
                    <ControlledReactSelect
                      label="Tipe Dokumen"
                      name="documentType"
                      control={control}
                      options={[
                        { value: "Rekomendasi Pengangkutan Bahan B3", label: "Rekomendasi Pengangkutan Bahan B3" },
                        { value: "Registrasi Bahan B3", label: "Registrasi Bahan B3" },
                        { value: "Notifikasi Bahan B3", label: "Notifikasi Bahan B3" },
                      ]}
                      isRequired={true}
                    />
                    <ControlledInput
                      label="Format Nomor Surat"
                      name="formatNomorSurat"
                      control={control}
                      isRequired={true}
                      placeholder="S.{nomorSurat}/PBSLB3-PB3/PPI/PLB.4.4/B/{bulan}/{tahun}"
                    />
                  </div>
                  <div className="flex items-center gap-2">
                    <Button type="submit" color="primary" isLoading={isSubmitting} disabled={isSubmitting}>
                      {isEdit ? "Simpan" : "Tambah"}
                    </Button>
                    <Button isDisabled={isSubmitting} color="danger" variant="faded" onPress={onClose}>
                      Batal
                    </Button>
                  </div>
                </form>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </RootAdmin>
  );
}
